import apiClient from '../client';
import type { TicketSchema, WithAgentPublicUserData } from '@appTypes';

// SAV Tickets API
export type { TicketSchema, WithAgentPublicUserData } from '@appTypes';

type TicketWithUserData = WithAgentPublicUserData<TicketSchema>;

/**
 * Fetch paginated SAV tickets
 */
export async function fetchSavPaginatedTickets(params?: { lastDocumentId?: string }): Promise<{ data: { [key: string]: TicketWithUserData }; lastDocumentId?: string } | undefined> {
  const response: any = await apiClient.get('/sav/tickets', {
    params: { lastDocumentId: params?.lastDocumentId },
  });
  return { data: response.data, lastDocumentId: response.lastDocumentId };
}
